import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';

export default function deleteAddress(params) {
    const { baseUrl, brandId, country, addressId, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of deleteAddress()');
    invariant(brandId, 'brandId is a required param of deleteAddress()');
    invariant(country, 'country is a required param of deleteAddress()');
    invariant(addressId, 'addressId is a required param of deleteAddress()');
    invariant(uberToken, 'uberToken is a required param of deleteAddress()');
    invariant(clientId, 'clientId is a required param of deleteAddress()');

    const headers = new Headers({ 'Content-Type': 'application/json' });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/contact/byAddressId/${addressId}`;

    return labelRequest(authenticatedRequest(new Request(url, { headers, method: 'DELETE' }), uberToken, clientId, clientSecret), 'deleteAddress');
}
